import {getToken, clearToken} from "./token";

const NODE_ENV = process.env.NODE_ENV

const headersDefault = () => {
    return {
        'Content-Type': 'application/json',
        'Authorization': `${getToken()}`,
    }
}

// export const DEV_URL = NODE_ENV === 'development' ?  'http://18.198.86.238:8000/api/v2' : `//${window.location.host}/api/v2`;
export const DEV_URL = NODE_ENV === 'development' ?  'http://accoxxo-1257020687.ca-central-1.elb.amazonaws.com/api/v2' : `//${window.location.host}/api/v2`;
// export const DEV_URL = NODE_ENV === 'development' ?  'https://api.mini-games.tech/api/v2' : `//${window.location.host}/api/v2`;

export const request = (url, options) => {
    return new Promise((res, rej) => {
        fetch(`${DEV_URL}${url}`, {headers: {...headersDefault(), ...options.headers}, ...options})
            .then(async (response) => {
                let data = null 
                switch(response.status) {
                    case 401: 
                        clearToken()
                        window.location.replace('/signin')
                    break;
                    case 400:
                        data = await response.json();
                        rej(data);
                    break;
                    case 200:
                        res(response.json());
                    break;
                    default:
                    data = await response.json();
                    rej(data.message);
                }
            })
    })
};

export const requestHeader = (url, options) => {
    return new Promise((res, rej) => {
        fetch(`${DEV_URL}${url}`, {headers: {...headersDefault(), ...options.headers}, ...options})
            .then(async (response) => { 
                let data = null 
                switch(response.status) {
                    case 401: 
                        clearToken()
                        window.location.replace('/signin')
                    break;
                    case 400:
                        data = await response.json();
                        rej(data);
                    break;
                    case 200: 
                        const headers = {}
                        for (var pair of response.headers.entries()) {
                        headers[pair[0]] = pair[1]
                        }
                        res(Promise.all([response.json(), Promise.resolve(headers)]));
                    break;
                    default:
                    data = await response.json();
                    rej(data.message);
                }
            })
    })
};

export const mltipartRequest = (url, options) => {
    return new Promise((res, rej) => {
        fetch(`${DEV_URL}${url}`, {headers: {'Authorization': `${getToken()}`, ...options.headers}, ...options})
            .then(async (response) => {
                if (response.status !== 200) {
                    const data = await response.json();
                    if (response.status === 400) {
                        return rej(data);
                    }
                    return rej(data.message);
                }

                res(response.json());
            })
    })
};
